<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
        <div class="form container px-2">
        <h5><b>B. QUALIFICATIONS</b></h5>
        <!--doctorate-->
        <div class="mb-4 text-start">
            <div class="mb-2">
                <b>B.1 &nbsp; &nbsp;Doctorate (date & awarding body):</b>
                <span class="ms-3" v-if="!doctorate && !doctorateAdding">
                    <button @click="resetEdit()" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#doctorateModal"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <div v-if="doctorate">
                <div class="mt-3">
                    <div class="d-flex align-items-center">
                        <div class="justify">
                            {{ doctorate.data }}
                        </div>
                        <div class="dropstart ms-3">
                            <button @click="resetEdit()" type="button" class="btn btn-outline-secondary" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul class="dropdown-menu">
                                <li v-if="doctorate.fileUrl">
                                    <a style="color: black;" :href="doctorate.fileUrl" target="_blank"><div class="view mb-1"><i class="fa-solid fa-eye ms-3"></i>&nbsp; &nbsp;View</div></a>
                                </li>
                                <li @click="editQualification('doctorate', doctorate.data, doctorate.fileUrl)" data-bs-toggle="modal" data-bs-target="#doctorateModal">
                                    <a class="dropdown-item" href="#"><div class="edit mb-1"><i class="fa fa-pencil" aria-hidden="true"></i>&nbsp; &nbsp;Edit</div></a>
                                </li>
                                <li @click="deleteQualification('doctorate')">
                                    <a class="dropdown-item" href="#"><div class="delete"><i class="fa-solid fa-trash-can"></i>&nbsp; &nbsp;Delete</div></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <hr>
                </div>
            </div>
        </div>

        <!--Doctorate modal-->
        <div class="modal fade" id="doctorateModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="qualificationLabel">Doctorate</h1>
                        <button id="close1" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="doctorate" class="form-label">Doctorate Details:</label>
                            <div>
                                <textarea rows="4" v-model="doctorateDetails" type="text" class="form-control"
                                    id="doctorateData" placeholder="e.g. PhD in Mechanical (Production) Engineering, (2017–2020), Rivers State University, Port Harcourt, Nigeria."></textarea>
                            </div>
                            <br>
                            <div>
                                <label for="doctorateUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="doctorateUrl" type="text" class="form-control" id="doctorateUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('doctorate')" type="button" class="btn btn-success">Update</button>
                    </div>
                </div>
            </div>
        </div>


        <!--masters-->
        <div class="mb-4 text-start">
            <div class="mb-2">
                <b class="text-wrap" style="max-width: 300px;">B.2 &nbsp; &nbsp;Masters (date & awarding body):</b>
                <span class="ms-3" v-if="!masters && !mastersAdding">
                    <button @click="resetEdit()" class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#mastersModal"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <div v-if="masters">
                <div class="mt-3">
                    <div class="d-flex align-items-center">
                        <div class="justify">
                            {{ masters.data }}
                        </div>
                        <div class="dropstart ms-3">
                            <button @click="resetEdit()" type="button" class="btn btn-outline-secondary" data-bs-toggle="dropdown" aria-expanded="false">
                                <i class="fa-solid fa-ellipsis"></i>
                            </button>
                            <ul class="dropdown-menu">
                                <li v-if="masters.fileUrl">
                                    <a style="color: black;" :href="masters.fileUrl" target="_blank"><div class="view mb-1"><i class="fa-solid fa-eye ms-3"></i>&nbsp; &nbsp;View</div></a>
                                </li>
                                <li @click="editQualification('masters', masters.data, masters.fileUrl)" data-bs-toggle="modal" data-bs-target="#mastersModal">
                                    <a class="dropdown-item" href="#"><div class="edit mb-1"><i class="fa fa-pencil" aria-hidden="true"></i>&nbsp; &nbsp;Edit</div></a>
                                </li>
                                <li @click="deleteQualification('masters')">
                                    <a class="dropdown-item" href="#"><div class="delete"><i class="fa-solid fa-trash-can"></i>&nbsp; &nbsp;Delete</div></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <hr>
                </div>
            </div>
        </div>

        <!--masters modal-->
        <div class="modal fade" id="mastersModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="qualificationLabel">Masters</h1>
                        <button id="close2" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="masters" class="form-label">Masters Details:</label>
                            <div>
                                <textarea rows="4" v-model="mastersDetails" type="text" class="form-control"
                                    id="mastersData" placeholder="e.g. M.Tech. in Mechanical (Production) Engineering, (2017–2020), Rivers State University, Port Harcourt, Nigeria."></textarea>
                            </div>
                            <br>
                            <div>
                                <label for="mastersUrl" class="form-label">Google Drive Link:</label>
                                <input v-model="mastersUrl" type="text" class="form-control" id="mastersUrl" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('masters')" type="button" class="btn btn-success">Update</button>
                    </div>
                </div>
            </div>
        </div>


        <!--Other qualifications-->
        <div class="mb-5 text-start">
            <div class="d-flex align-items-center">
                <div>
                    <b>
                        B.3 &nbsp; &nbsp;Other relevant academic or professional qualifications (including appointment, confirmation, and promotion letters) and Google Scholar profile:
                    </b>
                </div>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#otherQualificationsModal">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=otherQualifications :type="'otherQualifications'"/>
        </div>

        <!-- Other qualifications Modal -->
        <div class="modal fade" id="otherQualificationsModal" tabindex="-1" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Other qualifications/letters</h1>
                        <button id="close3" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 mx-4 text-start">
                            <label for="exampleFormControlInput124" class="form-label me-3">Describe qualification/letter:</label>
                            <textarea rows="5" v-model="otherQualification" type="text" class="form-control"
                                id="exampleFormControlInput4" placeholder="e.g. Since 2020, registered Mechanical Engineer (Reg. No. R58889) by the Council for the Regulation of Engineering in Nigeria (COREN)."></textarea>
                            <br>
                                <label for="qualification" class="form-label">Google Drive Link:</label>
                                <input v-model="qualificationUrl" type="text" class="form-control" id="qualification" placeholder="e.g. https://drive.google.com/file/d/0B2qNXhBbYeLpc3RhcnRlcl9maWxl/view?usp=sharing&resourcekey=0-KcYGWMmUv-6g0bfg046jCg">
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails('otherQualifications')" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row-reverse mb-5">
            <button type="button" @click="saveSection('next')" class="btn btn-success me-3">Save & Continue</button>
            <button type="button" @click="saveSection('previous')" class="btn btn-success me-3">Previous Section</button>
        </div>
    </div>
    </div>
</Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionB',
    emits: ['toggleLoader', 'setSection', 'submitted'],
    data() {
        return {
            candidate: '',
            doctorate: '',
            doctorateDetails: '',
            doctorateUrl: '',
            masters: '',
            mastersDetails: '',
            mastersUrl: '',
            otherQualification: '',
            qualificationUrl: '',
            otherQualifications: [],
            doctorateAdding: false,
            doctorateDeleting: false,
            mastersAdding: false,
            mastersDeleting: false,
            qualificationAdding: false,
            qualificationDeleting: false,
            qualificationData: '',
            doctorateEditing: false,
            mastersEditing: false,
            editUpload: false,
            key: 0
        }
    },
    created() {
        this.$emit('setSection', 'Section B');
        this.setData()
    },
    methods: {
        resetEdit(){
            //removes edit section if present on the page
            for (var i=0; i < this.otherQualifications.length; i++) {
                this.otherQualifications[i].editing = false
            }
        },
        //for only doctorate and masters
        editQualification(qualification, qualificationData, fileUrl){
            //set data (details of qualification) in case user empties details textarea
            if (qualification == 'doctorate') {
                this.doctorateEditing = true
                setTimeout(() => {
                    document.getElementById('doctorateData').focus()
                }, 500);
                this.doctorateDetails = qualificationData;
                this.doctorateUrl = fileUrl
            } else if (qualification == 'masters') {
                this.mastersEditing = true
                setTimeout(() => {
                    document.getElementById('mastersData').focus()
                }, 500);
                this.mastersDetails = qualificationData;
                this.mastersUrl = fileUrl
            }
        },
        async saveSection(page) {
            this.$emit('toggleLoader');

            var dataDetails = {
                doctorate: this.doctorate,
                masters: this.masters,
                otherQualifications: this.otherQualifications
            }

            const candidate = await DataService.saveData(dataDetails)

            if (candidate) {
                this.doctorate = candidate.doctorate;
                this.doctorateEditing = false;
                this.masters = candidate.masters;
                this.mastersEditing = false;

                this.doctorateDetails = '';
                this.doctorateUrl = '';
                this.mastersDetails = '';
                this.mastersUrl = '';

                if (page == 'previous') {
                    this.$router.push('/sectiona')
                } else if (page == 'next') {
                    this.$router.push('/sectionc')
                }
            }

            this.$emit('toggleLoader');
        },
        async joinDetails(category) {
            this.$emit('toggleLoader');
            
            if (category == 'doctorate' && this.doctorateDetails) {
                this.doctorate = {
                    data: this.doctorateDetails,
                    fileUrl: !/^https?:\/\//i.test(this.doctorateUrl) ? this.doctorateUrl ? "https://" + this.doctorateUrl : '' : this.doctorateUrl
                }
            } else if (category == 'doctorate' && !this.doctorateDetails){
                alert('Fill Doctorate details');
            }

            if (category == 'masters' && this.mastersDetails) {
                this.masters = {
                    data: this.mastersDetails,
                    fileUrl: !/^https?:\/\//i.test(this.mastersUrl) ? this.mastersUrl ? "https://" + this.mastersUrl : '' : this.mastersUrl
                }
            } else if (category == 'masters' && !this.mastersDetails) {
                alert('Fill Masters details');
            }

            if (category == 'otherQualifications' && this.otherQualification) {
                this.otherQualifications.unshift({ data: this.otherQualification, fileUrl: !/^https?:\/\//i.test(this.qualificationUrl) ? this.qualificationUrl ? "https://" + this.qualificationUrl : '' : this.qualificationUrl});
                document.getElementById('close3').click();
                this.otherQualification = '';
                this.qualificationUrl = '';
                this.key += 1
            } else if (category == 'otherQualifications' && !this.otherQualification){
                alert('Fill qualification details')
            }

            document.getElementById('close1').click();
            document.getElementById('close2').click();

            this.$emit('toggleLoader')
        },
        
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            
            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id);

            if (candidate) {
                if ((candidate.staffType == "Junior Non-academic") || (candidate.staffType == "Senior Non-academic")) {
                    this.$emit('toggleLoader');
                    this.$router.push({ path: `/section1` });
                    return
                }
                this.$emit('submitted', candidate.submitted);
                this.candidate = candidate;
                this.doctorate = candidate.doctorate ? candidate.doctorate : '';
                this.masters = candidate.masters ? candidate.masters : '';
                this.otherQualifications = candidate.otherQualifications ? candidate.otherQualifications : [];
            }
            
            this.$emit('toggleLoader');
        },
        async deleteQualification(qualificationType, qualificationIndex) {
            this.$emit('toggleLoader');
            if (qualificationType == 'doctorate') {
                var fileDetails = {
                    fileType: 'doctorate'
                }           
            }

            if (qualificationType == 'masters') {
                var fileDetails = {
                    fileType: 'masters'
                }
            }

            const candidate = await DataService.deleteFile(fileDetails);

            if (candidate) { 
                this.candidate = candidate;
                this.doctorate = candidate.doctorate ? candidate.doctorate : '';
                this.masters = candidate.masters ? candidate.masters : '';
            }

            this.doctorateDetails = '';
            this.doctorateUrl = '';
            this.mastersDetails = '';
            this.mastersUrl = '';
            this.$emit('toggleLoader');
        }
    }
}
</script>